import { memo as Memo, useMemo, useCallback, useRef } from 'react'
import gsap from 'gsap'

//* Components
import Image from 'components/common/Image'
import Video from 'components/common/Video'
import { Swiper, SwiperSlide } from 'swiper/react'
import { FreeMode } from 'swiper'

//* Styles
import LinearSliderStyle from './style'

const LinearSlider = Memo(({ items }) => {
    //! Refs
    const cursorRef = useRef()

    //! Single Slide
    const slideContent = useCallback((item, type) => {
        return (
            item && (
                <div className={`ls-item-inner-cont ${type}`}>
                    {item.type === 'video' ? <Video src={item.url} /> : <Image objectFit={'cover'} src={item.url} alt={item.alt} />}
                </div>
            )
        )
    }, [])

    //! Slides
    const slides = useMemo(() => {
        const slidesArray = []

        const list = [...items]

        if (list.length < 8) {
            for (let k = 0; k < 8 - list.length; k++) {
                list.push(list[k % 8])
            }
        }

        for (let i = 0; i < list.length; i++) {
            let slide

            if ((i + 1) % 3 === 0) {
                slide = (
                    <SwiperSlide key={i} className='big-slide'>
                        {slideContent(list[i], 'big')}
                    </SwiperSlide>
                )
            } else {
                slide = list[i + 2] && (
                    <SwiperSlide key={i} className='double-slide'>
                        {slideContent(list[i], `top-slide top-${i % 2 === 0 ? 'right' : 'left'}-slide`)}
                        {slideContent(list[i + 1], 'bottom-slide')}
                    </SwiperSlide>
                )
                i++
            }

            slide && slidesArray.push(slide)
        }

        return slidesArray
    }, [items])

    //! Handle Container Mouse Move
    const handleContainerMouseMove = useCallback(
        (e) => {
            gsap.to(cursorRef.current, { duration: 0.3, opacity: 1, left: e.clientX, top: e.clientY })
        },
        [cursorRef.current]
    )

    //! Handle Container Mouse Leave
    const handleContainerMouseLeave = useCallback(() => {
        gsap.killTweensOf([cursorRef.current])
        gsap.set(cursorRef.current, { opacity: 0 })
    }, [cursorRef.current])

    return (
        <LinearSliderStyle onMouseMove={handleContainerMouseMove} onMouseLeave={handleContainerMouseLeave}>
            <Swiper
                slidesPerView={'auto'}
                // shortSwipes={true}
                // loopFillGroupWithBlank={true}
                freeMode={{
                    enabled: true,
                    // minimumVelocity: 0.2,
                    // momentumBounceRatio: 0.5,
                    // momentumRatio: 1,
                    // momentumVelocityRatio: 0.5,
                    // momentumBounce: false,
                    // freeModeMomentum: false,
                }}
                loop={true}
                modules={[FreeMode]}
            // cssMode={true}
            >
                {slides}
                {slides}
            </Swiper>

            <span ref={cursorRef} className='cursor-drag font-soundscape secondaryColor1-bg p pS'>
                Drag
            </span>
        </LinearSliderStyle>
    )
})

export default LinearSlider
